import { AuthorizedOperations } from "./authorized-operations.model";
import { BaseModel } from "./base.model";
import { LoginType } from "./members/user/user-context.model";

export class AuthContext extends BaseModel { 
    ownerId?: string;
    roles: string[] = [];
    loginType?: LoginType;
    authorizedOperations?: AuthorizedOperations;    
}